export const RELATORIO_LOAD = "RELATORIO_LOAD";
export const RELATORIO_LOAD_CSV = "RELATORIO_LOAD_CSV";
